import { Injectable, inject } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { first } from 'rxjs/operators';

import { ModalComponent } from '../modal.component';
import { ModalType } from '../modal-type.enum';

@Injectable({
    providedIn: 'root'
})
export class ModalService {
    private readonly modalService = inject(BsModalService);


    public openInformationModal(
        modalType: ModalType,
        message: string,
        onSuccess: Function,
        onFailure?: Function,
        focusPrimaryButton?: boolean,
        parameter?: any
    ): void {
        const modalRef = this.modalService.show(ModalComponent, { backdrop: 'static' });
        modalRef.content.message = message;
        modalRef.content.focusPrimaryButton = focusPrimaryButton;
        modalRef.content.parameter = parameter;
        modalRef.content.modalType = modalType;

        this.modalService.onHide.pipe(first()).subscribe((reason: string) => {
            if (reason === 'confirm') {
                onSuccess();
            } else if (onFailure) {
                onFailure();
            }
        });
    }

    public openCustomModal(
        content: any,
        onSuccess?: Function,
        onFailure?: Function,
        parameter?: any,
        wide?: boolean
    ): void {
        const modalRef = this.modalService.show<any>(content, {
            backdrop: 'static',
            class: wide ? 'modal-wide' : ''
        });

        modalRef.content.parameter = parameter;

        modalRef.content.confirm$?.pipe(first()).subscribe((value: any) => {
            if (onSuccess) {
                onSuccess(value);
            }
            modalRef.hide();
        });

        modalRef.content.cancel$?.pipe(first()).subscribe((value: any) => {
            if (onFailure) {
                onFailure(value);
            }
            modalRef.hide();
        });
    }
}
